import { useDispatch, useSelector } from 'react-redux';

import { AppState } from 'interfaces/store';
import {
  set2DImageAction,
  set3DImageAction,
} from 'store/actions/calculator';
import {
  Vector3,
  WebGLRenderer,
} from 'three';
import { useState } from 'react';
import {
  DEFAULT_2D_VECTOR_VIEW,
  EXPORT_IMAGE_MIME_TYPE,
  IMAGE_EXPORT_3D_VECTOR_VIEW,
} from '@organisms/Pallet3D/config';
import Pattern from '@classes/3d/patterns/Pattern';

let rendered: WebGLRenderer;
let pattern: Pattern;

const useImagesState = () => {
  const [isSaving, setIsSaving] = useState(false);

  
  const dispatch = useDispatch();
   
  const {
    images = {},
  } = useSelector(({ calculator }: AppState) => calculator);

  const {
    i2d,
    i3d,
  } = images;

  const on3DPalletReady = (
    currenPattern: Pattern,
    currentRenderer: WebGLRenderer,
  ) => {
    rendered = currentRenderer;
    pattern = currenPattern;
  };

  const saveImage = (vector: Vector3, is3D: boolean = false): Promise<string> => {
    if (!pattern.camera) {
      return Promise.resolve('');
    }

    setIsSaving(true);
    pattern.camera.position.set(vector.x, vector.y, vector.z);
    if (is3D) {
      pattern.fixCameraPosition();
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        const image = rendered.domElement.toDataURL(EXPORT_IMAGE_MIME_TYPE);
        resolve(image);
      }, 100);
    });
  };

  const save2DImage = (): Promise<string> => saveImage(DEFAULT_2D_VECTOR_VIEW).then(
    (image: string) => {
      dispatch(set2DImageAction(image));
      return image;
    },
  );

  const save3DImage = (): Promise<string> => saveImage(IMAGE_EXPORT_3D_VECTOR_VIEW, true).then(
    (image: string) => {
      dispatch(set3DImageAction(image));
      return image;
    },
  );

  return {
    i2d,
    i3d,
    isSaving,
    on3DPalletReady,
    setIsSaving,
    save2DImage,
    save3DImage,
  };
};

export default useImagesState;
